import React from 'react';
import classNames from 'classnames/bind';

import withStyles from 'lib/enhancers/withStyles';
import Table, { TableProps } from 'components/helpers/Table/Table';
import Loader, { LoaderVariant } from 'components/helpers/Loader/Loader';

import styles from './PlanComparisonTable.module.scss';
import { PlanComparisonTableFields, usePlanComparisonTable } from './usePlanComparisonTable';
import type { ComponentProps } from 'lib/component-props';

const cx = classNames.bind(styles);

export type PlanComparisonTableProps = ComponentProps & {
  fields: PlanComparisonTableFields;
};

type PlanComparisonTableViewProps = {
  isLoading: boolean;
  showNoResultsFound: boolean;
  tables: TableProps[];
};

const PlanComparisonTableView = ({ isLoading, showNoResultsFound, tables }: PlanComparisonTableViewProps) => {
  if (isLoading) {
    return (
      <div role="status">
        <span className={cx('screen-reader-only')}>Plan details loaded</span>
        <Loader variant={LoaderVariant.Spinner} />
        <br />
        <br />
      </div>
    );
  }

  if (showNoResultsFound) {
    return (
      <div role="status">
        <strong className={cx('no-plan')}>Error loading plans. Please try again at a later time.</strong>
        <br />
        <br />
      </div>
    );
  }

  return (
    <div className={cx('plan-comparison-page-wrapper')}>
      {tables.map((thistable) => (
        <div key={thistable.id} className={cx('plan-comparison-table-wrapper')}>
          <Table {...thistable}></Table>
        </div>
      ))}
    </div>
  );
};

const PlanComparisonTable = (props: PlanComparisonTableProps) => {
  const { isLoading, tables, showNoResultsFound } = usePlanComparisonTable({
    fields: props.fields,
    cx: cx,
    planSearchPage: props.fields?.planType?.fields?.planSearchPage,
  });
  return <PlanComparisonTableView isLoading={isLoading} tables={tables} showNoResultsFound={showNoResultsFound} />;
};

export default withStyles()<PlanComparisonTableProps>(PlanComparisonTable);
